import { Trans, msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";

import { getAnalyticsAdapter } from "../../analytics/AnalyticsAdapter";
import { declineAnalytics } from "../../analytics/consentActions";
import { useConsentStore } from "../../state/consentStore";
import { useGameStore } from "../../state/store";
import { Button } from "../common/Button";
import styles from "./ConsentBanner.module.css";

export function ConsentBanner(): JSX.Element {
  const { i18n } = useLingui();
  const accept = useConsentStore((state) => state.accept);
  const decline = useConsentStore((state) => state.decline);
  const navigateTo = useGameStore((state) => state.navigateTo);

  const handleDecline = (): void => {
    declineAnalytics(getAnalyticsAdapter(), { decline });
  };

  return (
    <div
      className={styles.banner}
      role="dialog"
      aria-live="polite"
      aria-label={i18n._(msg`Согласие на аналитику`)}
    >
      <p className={styles.text}>
        <Trans>
          Мы используем анонимную аналитику (PostHog, Sentry; серверы в ЕС), чтобы улучшать
          игру. Личные данные не собираются. Можно отказаться.
        </Trans>
      </p>
      <div className={styles.actions}>
        <Button variant="ghost" size="small" onClick={() => navigateTo("privacy")}>
          <Trans>Подробнее</Trans>
        </Button>
        <Button variant="secondary" size="small" onClick={handleDecline}>
          <Trans>Отказаться</Trans>
        </Button>
        <Button variant="primary" size="small" onClick={() => accept()}>
          <Trans>Принять</Trans>
        </Button>
      </div>
    </div>
  );
}
